import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Gift, Scissors } from 'lucide-react';

export default function ArtikelDIYTischdeko() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]">
      <section className="py-16 md:py-24 bg-[#4A5D4F]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/ratgeber" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors"><ArrowLeft className="w-4 h-4" />Alle Ratgeber</Link>
          <div className="flex items-center gap-2 text-[#D4C5A9] text-sm mb-4"><Calendar className="w-4 h-4" /><span>Februar 2026</span></div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight">DIY Ramadan & Eid Tischdeko</h1>
          <p className="text-lg text-white/80 leading-relaxed">Einfache Anleitungen für eine festliche Tafel – günstig und wunderschön.</p>
        </div>
      </section>
      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12 prose prose-lg max-w-none">
          <p className="text-xl text-[#2C332E] leading-relaxed mb-8">Eine festlich gedeckte Tafel macht das Iftar und das Eid-Essen zu etwas Besonderem. Mit diesen DIY-Ideen zauberst du eine wunderschöne Tischdeko – ohne viel Geld auszugeben!</p>

          <section className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center"><Scissors className="w-6 h-6 text-[#4A5D4F]" /></div>
              <h2 className="font-serif text-2xl font-medium text-[#2C332E]">Mittelstücke / Centerpieces</h2>
            </div>
            <div className="space-y-6">
              <div className="bg-[#F5F5F0] rounded-xl p-6">
                <h4 className="font-medium text-[#2C332E] mb-3">🌙 Mond-Laterne</h4>
                <div className="bg-white rounded-lg p-4">
                  <p className="text-sm font-medium text-[#2C332E] mb-2">Du brauchst:</p>
                  <ul className="text-sm text-[#4B5563] space-y-1 mb-3">
                    <li>• Einmachglas oder Vase</li>
                    <li>• Goldene Sprühfarbe oder Goldfolie</li>
                    <li>• Mond-Schablone</li>
                    <li>• LED-Lichterkette</li>
                  </ul>
                  <p className="text-sm text-[#4B5563]">Mond-Form auf das Glas kleben, drumherum sprühen/bekleben, Schablone entfernen, Lichter hineingeben.</p>
                </div>
              </div>

              <div className="bg-[#F5F5F0] rounded-xl p-6">
                <h4 className="font-medium text-[#2C332E] mb-3">🌸 Dattel-Blumen-Arrangement</h4>
                <div className="bg-white rounded-lg p-4">
                  <p className="text-sm text-[#4B5563]">Eine flache Schale mit Datteln füllen und mit frischen Blumen oder Eukalyptuszweigen umrahmen. Natürlich und elegant!</p>
                </div>
              </div>

              <div className="bg-[#F5F5F0] rounded-xl p-6">
                <h4 className="font-medium text-[#2C332E] mb-3">✨ Schwimmkerzen-Schale</h4>
                <div className="bg-white rounded-lg p-4">
                  <p className="text-sm text-[#4B5563]">Glasschale mit Wasser füllen, Schwimmkerzen und Blütenblätter hinzufügen. Optional: Goldglitzer auf dem Wasser.</p>
                </div>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Serviettenringe & Platzhalter</h2>
            <div className="space-y-6">
              <div className="bg-[#F5F5F0] rounded-xl p-6">
                <h4 className="font-medium text-[#2C332E] mb-3">🌙 Mond-Serviettenringe</h4>
                <div className="bg-white rounded-lg p-4">
                  <p className="text-sm text-[#4B5563]">Monde aus goldenem Karton ausschneiden, ein Loch stanzen und mit einem Band an der gefalteten Serviette befestigen.</p>
                </div>
              </div>

              <div className="bg-[#F5F5F0] rounded-xl p-6">
                <h4 className="font-medium text-[#2C332E] mb-3">📛 Namenskarten mit Dattel</h4>
                <div className="bg-white rounded-lg p-4">
                  <p className="text-sm text-[#4B5563]">Kleine Kärtchen beschriften und in eine Dattel stecken. Die Dattel ist gleichzeitig Platzhalter und erste Iftar-Leckerei!</p>
                </div>
              </div>

              <div className="bg-[#F5F5F0] rounded-xl p-6">
                <h4 className="font-medium text-[#2C332E] mb-3">🎀 Einfache Stoffband-Ringe</h4>
                <div className="bg-white rounded-lg p-4">
                  <p className="text-sm text-[#4B5563]">Goldenes oder grünes Samtband um die Serviette binden, mit kleinem Stern oder Mond-Anhänger verzieren.</p>
                </div>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Tischläufer & Unterlagen</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Papier-Tischläufer</h4>
                <p className="text-sm text-[#4B5563]">Goldenes oder weißes Packpapier als Läufer, darauf mit Schablonen Monde und Sterne stempeln.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Konfetti-Streuung</h4>
                <p className="text-sm text-[#4B5563]">Goldene Sterne und Monde als Konfetti auf dem Tisch verteilen. Einfach aber effektvoll!</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Stoffuntersetzer</h4>
                <p className="text-sm text-[#4B5563]">Aus Stoffresten runde Untersetzer nähen oder mit Zackenschere ausschneiden.</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Beleuchtung</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Teelichtgläser</h4>
                <p className="text-sm text-[#4B5563]">Leere Gläser mit Spitzenband oder goldener Farbe verzieren, LED-Teelicht hinein.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Papier-Windlichter</h4>
                <p className="text-sm text-[#4B5563]">Aus Transparentpapier mit ausgestanzten Mustern – zauberhafter Lichteffekt!</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Fairy Lights im Glas</h4>
                <p className="text-sm text-[#4B5563]">Batteriebetriebene Mikro-Lichterketten in Einmachgläsern – magisch!</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Einkaufsliste</h2>
            <div className="bg-[#4A5D4F]/10 rounded-xl p-6">
              <p className="text-[#4B5563] mb-3">Basics, die du brauchst:</p>
              <ul className="text-[#4B5563] space-y-2">
                <li>✓ Goldenes/weißes Tonpapier</li>
                <li>✓ Schere, Stanzer (Stern/Mond)</li>
                <li>✓ Kleber, doppelseitiges Klebeband</li>
                <li>✓ LED-Teelichter & Lichterketten</li>
                <li>✓ Bänder (Gold, Samt, Jute)</li>
                <li>✓ Einmachgläser</li>
                <li>✓ Stoffservietten</li>
              </ul>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Fazit</h2>
            <p className="text-[#4B5563] leading-relaxed mb-4">DIY-Tischdeko macht nicht nur Spaß beim Basteln, sondern auch beim Bewundern. Mit ein paar einfachen Materialien schaffst du eine Tafel, die sich sehen lassen kann!</p>
            <p className="text-xl text-[#4A5D4F] font-medium">Eid Mubarak! 🌙</p>
          </section>

          <div className="bg-[#F5F5F0] rounded-2xl p-6 mb-8">
            <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-4">Weitere Artikel</h3>
            <ul className="space-y-2">
              <li><Link to="/ratgeber/eid-deko-ideen" className="text-[#4A5D4F] hover:underline">→ Eid Deko Ideen für Zuhause</Link></li>
              <li><Link to="/ratgeber/diy-eid-geschenke" className="text-[#4A5D4F] hover:underline">→ DIY Eid Geschenke</Link></li>
            </ul>
          </div>

          <div className="bg-[#4A5D4F] rounded-2xl p-8 text-center">
            <h3 className="font-serif text-2xl font-medium text-white mb-4">Geschenke entdecken</h3>
            <Link to="/geschenke" className="inline-flex items-center gap-2 bg-white text-[#4A5D4F] px-8 py-3 rounded-full font-medium hover:bg-[#D4C5A9] transition-colors">Jetzt stöbern<Gift className="w-5 h-5" /></Link>
          </div>
        </div>
      </article>
    </main>
  );
}
